import { useLocation } from "react-router-dom";
import queryString from "query-string";

export default function useLine() {
  const location = useLocation();
  const line = queryString.parse(location.search).line || null;

  return line;
}
